
import {
  getDateFormate,
  getTotalDays,
} from "../AllDateTimeReleventFormate";

export default function RentalDetailsLabel({ item }) {
  const formatTime = (time) => {
    const [hour, minutes] = time.split(":");
    const date = new Date();
    date.setHours(hour, minutes);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
  };
  return (
    <div>
      <p>
        <span> From {getDateFormate(item?.start_date)}, {item?.start_time && formatTime(item?.start_time)}</span>
        <div className="from-date">
          <span>To {item?.end_date && getDateFormate(item?.end_date)}, {item?.end_time && formatTime(item?.end_time)}</span>
          <span className="first-span">
            <span className="first-span">
              {getTotalDays(item.start_date, item.end_date, item.start_time, item.end_time)}
            </span>
          </span>
          <span className="second-span">
            {" "}
            {item?.rental_type == 2 ? "With Interpreter" : "Rental only"}
          </span>
        </div>
      </p>
    </div>
  );
}
